import axiosConfig from '@lib/axiosConfig';

export const OmbudsmanManifestationService = {

    list: async function () {
        return await axiosConfig.get('/ombudsman-manifestations');
    },

    show: async function (id) {
        return await axiosConfig.get(`/ombudsman-manifestations/show/${id}`);
    },

    fetchbyfilter: async function (filter, order=null, limit=null) {
        return await axiosConfig.get(`/ombudsman-manifestations/fetchbyfilter/${filter}/${order}/${limit}`);
    },

    store: async function (data) {
        return await axiosConfig.post('/ombudsman-manifestations/store', data);
    },

    update: async function (data, id) {
        return await axiosConfig.put(`/ombudsman-manifestations/update/${id}`, data);
    },

    remove: async function (id) {
        return await axiosConfig.delete(`/ombudsman-manifestations/remove/${id}`);
    },

    dashboard: async function (data) {
        return await axiosConfig.post('/ombudsman-manifestations/dashboard', data);
    },

};